import { render } from "./impersonate.vue?vue&type=template&id=2d5af00d&scoped=true&ts=true&lang=pug"
import script from "./impersonate.vue?vue&type=script&lang=ts"
export * from "./impersonate.vue?vue&type=script&lang=ts"

import "./impersonate.vue?vue&type=style&index=0&id=2d5af00d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5af00d"]])

export default __exports__